export default {
    name: "SetModel",
    title: "Set Model Data",
    icon: "mdi-content-save-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            source: [],
            targetName: null
        };
    },
};